export default __webpack_public_path__ + "static/media/illustration-health-1-m@3x.6f9b82da.webp";